import BaseModel from './BaseModel';
import { PAGINATION } from '../constants/Define';
export default class Agent extends BaseModel {
    constructor(data = {}) {
        super(data);
        this.setData(data)
    }

    setData(data = this.__data__) {
        this.id = data.id;
        this.name = data.name || undefined;
        this.email = data.email || undefined;
        this.phoneNumber = data.phoneNumber || undefined;
        this.taxNumber = data.taxNumber || undefined;
        this.address = data.address || undefined;
        this.contactFullname = data.contactFullname || undefined;
        this.contactEmail = data.contactEmail || undefined;
        this.contactPhoneNumber = data.contactPhoneNumber || undefined;
        this.createdDate = data.createdDate || undefined;
        this.setDetail(data.detail || {});
    }

    setDetail(data={}){
        this.detail = {
            pageIndex: data.pageIndex || PAGINATION.pageIndex,
            pageSize: data.pageSize || PAGINATION.pageSize,
            totalCount: data.totalCount || 0,
            totalPage: Math.ceil(parseInt(data.totalCount || 0) / parseInt(data.pageSize || PAGINATION.pageSize)),
            orderBy: data.orderBy,
            orderByDesc: data.orderByDesc,
            items: (data.result || data.items || []).map(item => new AgentReports(item))
        }
    }

    export() {
        const result = super.export({
            id: this.id,
            name: this.name,
            email: this.email,
            phoneNumber: this.phoneNumber,
            taxNumber: this.taxNumber,
            address: this.address,
            contactFullname: this.contactFullname,
            contactEmail: this.contactEmail,
            contactPhoneNumber: this.contactPhoneNumber
        });
        return result;
    }

}


export class AgentReports {
    constructor(data = {}) {
        this.setData(data)
    }

    setData(data = {}) {
        this.groupId = data.groupId || undefined;
        this.groupCode = data.groupCode || undefined;
        this.groupName = data.groupName || undefined;
        this.quantity = data.quantity || 0;
    }
}